/**
 * Normaliza un parámetro de checklist asegurando que tenga todas las propiedades requeridas
 * @param {Object} param - El parámetro a normalizar
 * @returns {Object} - El parámetro normalizado con todas las propiedades
 */
export const normalizeChecklistParameter = (param) => {
  if (!param) return null

  return {
    name: param.name || '',
    description: param.description || '',
    value: param.value || 'pending',
    documentationLink: param.documentationLink || '',
    extraInfo: param.extraInfo || null,
    customCheckMethod: param.customCheckMethod || '',
    customCheckMethodValidatedData: param.customCheckMethodValidatedData || null,
    timestamp: param.timestamp || null,
    user: '',
    comment: param.comment || ''
  }
}

/**
 * Normaliza todos los parámetros en todas las secciones de un checklist
 * @param {Object} checklistData - Datos del checklist a normalizar
 * @returns {Object} - Checklist con todos los parámetros normalizados
 */
export const normalizeChecklistData = (checklistData) => {
  if (!checklistData || !checklistData.values || !checklistData.values.sections) {
    return checklistData
  }

  const sections = checklistData.values.sections
  for (const sectionKey in sections) {
    const section = sections[sectionKey]
    section.value = section.value || 'pending'
    if (section && section.parameters) {
      for (const paramKey in section.parameters) {
        section.parameters[paramKey] = normalizeChecklistParameter(section.parameters[paramKey])
      }
    }
  }

  return checklistData
}
